import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-screen-warning-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './screen-warning-dialog.component.html',
  styleUrl: './screen-warning-dialog.component.scss',
})
export class ScreenWarningDialogComponent {}
